import styles from './RiseClinicHeadline.module.css';

export const RiseClinicHeadline = () => {
  return (
    <div className={styles.container}>
      <p className={styles.tagline}>Better sleep starts here</p>
      <h1 className={styles.title}>RISE Clinic</h1>
      <p className={styles.subtitle}>Reserve your session.</p>
      <p className={styles.price}>$0 Due Today</p>
    </div>
  );
};
